import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Bestellinformationen',
  sections: {
    driver_info: 'Fahrer-Info',
    order_info: 'Bestell-Informationen',
    price_info: 'Preis-Information',
    adjustments: 'Anpassungen',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Abholung',
    [OrderMethod.Delivery]: 'Lieferung',
    [OnSiteLocationType.RoomService]: 'Zimmerservice',
    [OnSiteLocationType.TableService]: 'Tischservice',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Zimmernummer',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Tischnummer',
    },
  },
  labels: {
    wolt_support: 'Wolt Support-Rufnummer: {{phone_number}}',
    wolt_support_text:
      'Bei Fragen zur Bestellung, zum Fahrer oder Problemen ruf Wolt an. Wichtig sag, dass es um eine <strong>Wolt Drive</strong> Bestellung geht',
    dummy_order: 'Test Bestellung',
    asap: 'ASAP',
    driver_name: 'Name des Fahrers',
    driver_phone_number: 'Telefon des Fahrers',
    pin_code: 'PIN',
    dropoff_pin_code: 'Lieferungs-PIN',
    original: 'Original',
    delivery_fee: 'Liefergebühr',
    tip: 'Trinkgeld',
    service_fee: 'Online Zuschlag',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal Gebühr',
    },
    promo_applied: {
      default: 'Werbeaktion angewendet',
      [CouponType.Reward]: 'Loyalty punkte angewandt',
      [CouponType.Cashback]: 'Loyalty punkte angewandt',
      [CouponType.PromoCode]: 'Werbeaktion angewendet',
      [CouponType.GiftCard]: 'Geschenkkarte angewandt',
    },
    tax: 'Taxes',
    total: 'Gesamt',
    online_payment: 'Kunde hat bereits in der {{provider}}-App bezahlt',
    cash_payment: 'Bezahlung vor Ort',
    invoice_payment: 'Zahlung auf Rechnung',
    old_order: 'Diese Bestellung wurde erfolgreich ausgeführt',
    pickup_time: 'Abholzeit',
    pickup_asap: 'Der Kunde hat um schnellstmögliche Abholung gebeten.',
    points_used: 'Diese Bestellung enthält eine eingelöste Treuepunkt-Prämie von einem loyalen Kunden.',
    order_instructions: 'Bestellanweisungen:',
    today: 'heute',
  },
  schedule: {
    header: 'Geplant für {{date}}, {{time}}',
    text: 'Wir erinnern dich daran, wenn es Zeit ist, mit der Zubereitung der Bestellung zu beginnen.',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Vom Kunden gewünscht',
    [RefundReason.Reclamation]: 'Reklamation',
    [RefundReason.CommunicationError]: 'Kommunikationsfehler',
    [RefundReason.Other]: 'Andere',
    [RefundReason.Dispute]: 'Kundenstreit',
    dispute_win: 'Gewonnener Kundenstreit',
    null: '',
  },
  toasts: {
    print_one: 'Drucken {{count}} Beleg: Bestell-Nr <strong>{{orderNumber}}</strong>...',
    print_other: 'Drucken {{count}} Belege: Bestell-Nr <strong>{{orderNumber}}</strong>...',
    refund_successful: 'Refund successful: Order <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Drucken',
    confirm: 'Als abgeholt markieren',
    reject: 'Ablehnen',
    refund: 'Erstatten',
  },
};
